module.exports = __webpack_public_path__ + "img/bitcoin-dashboard.dc955a38.png";